import { AuditFields } from 'Portals/Customer/entities'
import i18n from 'Portals/Customer/utils/i18nService'

export const getMobileSortingColumn = (): LabelValue[] => [
	{
		label: i18n.t('pages:audit.sorting.created'),
		value: AuditFields.createDate
	},
	{
		label: i18n.t('pages:audit.sorting.updated'),
		value: AuditFields.lastUpdateDate
	}
]
